import { useSwiper } from "swiper/react";

const SlideQuickTooltip = () => {
  const swiper = useSwiper();
  //slide to widget download page
  return <button onClick={() => swiper.slideTo(3)}>Skip Quick Tooltip</button>;
};

export default SlideQuickTooltip;
